import { render, staticRenderFns } from "./VisitPaymentCashModal.vue?vue&type=template&id=20c7b188"
import script from "./VisitPaymentCashModal.vue?vue&type=script&lang=js"
export * from "./VisitPaymentCashModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports